import { useMemo } from "react";
import { Group } from "@mantine/core";
import { formatBtc, formatCog, formatCogtoshiPerSat } from "../units";
import { Stat } from "./Stat";

interface EfficiencyGridProps {
  // Structural — both DomainMiningEfficiency and WalletMiningEfficiency satisfy this.
  readonly totals: {
    readonly submissions: number;
    readonly wins: number;
    readonly gateFailures: number;
    readonly cogtoshiWon: bigint;
    readonly satsSpent: bigint;
  };
}

export function EfficiencyGrid({ totals }: EfficiencyGridProps) {
  const ratio = useMemo(
    () => formatCogtoshiPerSat(totals.cogtoshiWon, totals.satsSpent),
    [totals.cogtoshiWon, totals.satsSpent],
  );
  return (
    <Group grow align="stretch">
      <Stat
        label="Submissions"
        value={totals.submissions.toString()}
        sub={`${totals.wins.toString()} wins · ${totals.gateFailures.toString()} gate-fails`}
      />
      <Stat
        label="COG won"
        value={formatCog(totals.cogtoshiWon, { groupIntegerDigits: true, minDecimals: 2 })}
        sub={`${totals.cogtoshiWon.toString()} cogtoshi`}
      />
      <Stat
        label="BTC fees spent"
        value={formatBtc(totals.satsSpent, { groupIntegerDigits: true, minDecimals: 2 })}
        sub={`${totals.satsSpent.toString()} sats`}
      />
      <Stat label="Cogtoshi / sat" value={ratio} sub="winning haul ÷ all fees paid" />
    </Group>
  );
}
